import React, { useContext, useEffect, useState, useRef } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { GlobalContext } from "../../GlobalDataContext/GlobalContext";
import MixLogo from "../../assets/images/logo.svg";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/common/Loader";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import {
  encryptString,
  // createSession,
  getAbhaProfile,
} from "../../services/apiUtils";
import { API_BASE_URL } from "../../config";
import authService from "../../../Services/authService";
import AadharConsentSection from "../../components/common/AadharConsentSection";

const AadharVerificationPage = () => {
  const { getDataByKey } = useContext(GlobalContext);
  const [adharFormated, setAdharFormated] = useState("");
  const [adharno, setAdharno] = useState("");
  // const [accessToken, setaccessToken] = useState("");
  const [adharEncrpt, setadharEncrpt] = useState("");
  const [txnId, setTxnId] = useState("");
  const [showOtpBox, setShowOtpBox] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [formatedMobile, setFormatedMobile] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [OtpText, setOtpText] = useState("");
  const [encryptAbhaOtp, setencryptAbhaOtp] = useState(null);
  const consentCheckboxRef = useRef(0);
  const aadharInputRef = useRef(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusClass, setStatusClass] = useState("");
  const [consent1, setConsent1] = useState(false);
  const [consent2, setConsent2] = useState(false);
  const [consent3, setConsent3] = useState(false);
  const [consent4, setConsent4] = useState(false);
  const [consent5, setConsent5] = useState(false);
  const [consent6, setConsent6] = useState(false);
  const [consent7, setConsent7] = useState(false);
  const [healthcareWorkerName, setHealthcareWorkerName] = useState(() => {
    try {
      const userData = authService.getUser();
      return (
        userData?.name ||
        userData?.username ||
        userData?.email?.split("@")[0] ||
        "Healthcare Worker"
      );
    } catch {
      return "Healthcare Worker";
    }
  });
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [acceptAll, setAcceptAll] = useState(false);
  const [showMoreConsent, setShowMoreConsent] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaSessionId, setCaptchaSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [showAadhar, setShowAadhar] = useState(false);
  const [showMobile, setShowMobile] = useState(false);
  const [resendCount, setResendCount] = useState(1);
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [showMobileTooltip, setShowMobileTooltip] = useState(false);
  const [showEmailScreen, setShowEmailScreen] = useState(false);
  const [showMobileOtpScreen, setShowMobileOtpScreen] = useState(false);
  const [mobileOtpTxnId, setMobileOtpTxnId] = useState("");
  const [mobileOtpText, setMobileOtpText] = useState("");
  const [mobileOtpResendCount, setMobileOtpResendCount] = useState(0);
  const [mobileOtpTimer, setMobileOtpTimer] = useState(0);
  const [mobileOtpError, setMobileOtpError] = useState("");
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [showAbhaAddressScreen, setShowAbhaAddressScreen] = useState(false);
  const [abhaAddressList, setAbhaAddressList] = useState([]);
  const [selectedAbhaAddress, setSelectedAbhaAddress] = useState("");
  const [xToken, setXToken] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isManualAddress, setIsManualAddress] = useState(false);
  const [isCheckingAddress, setIsCheckingAddress] = useState(false);
  const [addressAvailable, setAddressAvailable] = useState(null);
  const [addressError, setAddressError] = useState("");
  const [showExistingAccountPopup, setShowExistingAccountPopup] =
    useState(false);
  const [existingAccountData, setExistingAccountData] = useState(null);
  const [selectedPhrAddress, setSelectedPhrAddress] = useState("");
  const [existingAccountPhrAddresses, setExistingAccountPhrAddresses] =
    useState([]);
  const [isFromExistingAccountFlow, setIsFromExistingAccountFlow] =
    useState(false);

  const navigate = useNavigate();

  /**
   * Validate ABHA Address Format
   * Rules:
   * 1. Minimum length - 8 characters
   * 2. Maximum length - 18 characters
   * 3. Special characters allowed - 1 dot (.) and/or 1 underscore (_)
   * 4. Special character dot and underscore should be in between. Special characters cannot be in the beginning or at the end
   * 5. Alphanumeric - only numbers, only letters or any combination of numbers and letters is allowed.
   */
  const validateAbhaAddress = (address) => {
    if (!address) {
      return { valid: false, error: "ABHA address is required" };
    }

    // Check minimum length
    if (address.length < 8) {
      return {
        valid: false,
        error: "ABHA address must be at least 8 characters",
      };
    }

    // Check maximum length
    if (address.length > 18) {
      return {
        valid: false,
        error: "ABHA address must not exceed 18 characters",
      };
    }

    // Check if special characters are at the beginning or end
    if (
      address.startsWith(".") ||
      address.startsWith("_") ||
      address.endsWith(".") ||
      address.endsWith("_")
    ) {
      return {
        valid: false,
        error: "Special characters (. or _) cannot be at the beginning or end",
      };
    }

    // Count dots and underscores
    const dotCount = (address.match(/\./g) || []).length;
    const underscoreCount = (address.match(/_/g) || []).length;
    const totalSpecialChars = dotCount + underscoreCount;

    // Check if there are more than 1 dot or 1 underscore combined
    if (totalSpecialChars > 2) {
      return {
        valid: false,
        error: "ABHA address can contain maximum 1 dot and/or 1 underscore",
      };
    }

    if (dotCount > 1) {
      return {
        valid: false,
        error: "ABHA address can contain maximum 1 dot (.)",
      };
    }

    if (underscoreCount > 1) {
      return {
        valid: false,
        error: "ABHA address can contain maximum 1 underscore (_)",
      };
    }

    // Check if address contains only alphanumeric and allowed special characters
    const validPattern = /^[a-zA-Z0-9._]+$/;
    if (!validPattern.test(address)) {
      return {
        valid: false,
        error:
          "ABHA address can only contain letters, numbers, dot (.) and underscore (_)",
      };
    }

    return { valid: true, error: "" };
  };

  // Generate captcha on mount
  useEffect(() => {
    generateCaptcha();
  }, []);

  // Countdown timer for resend OTP
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0 && showOtpBox && resendCount < 3) {
      setCanResend(true);
    }
  }, [countdown, showOtpBox, resendCount]);

  const generateCaptcha = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/abha/captcha/generate`);
      if (response.data.success) {
        setCaptchaSessionId(response.data.data.sessionId);
        setCaptchaImage(response.data.data.captchaImage);
        setCaptchaInput("");
      } else {
        toast.error("Failed to generate captcha. Please try again.");
      }
    } catch (error) {
      console.error("Error generating captcha:", error);
      toast.error("Failed to generate captcha. Please try again.");
    }
  };

  // Handle Accept All checkbox
  const handleAcceptAll = (checked) => {
    setAcceptAll(checked);
    setConsent1(checked);
    setConsent2(checked);
    setConsent3(checked);
    setConsent4(checked);
    setConsent5(checked);
    setConsent6(checked);
    setConsent7(checked);
  };

  // Update Accept All when individual consents change
  useEffect(() => {
    const allChecked =
      consent1 &&
      consent2 &&
      consent3 &&
      consent4 &&
      consent5 &&
      consent6 &&
      consent7;
    setAcceptAll(allChecked);
  }, [consent1, consent2, consent3, consent4, consent5, consent6, consent7]);

  // Check if all required consents are checked
  const areAllConsentsChecked = () => {
    return (
      consent1 &&
      consent2 &&
      consent3 &&
      consent4 &&
      consent5 &&
      consent6 &&
      consent7
    );
  };

  // Check if address is manually entered or from suggestions
  useEffect(() => {
    if (selectedAbhaAddress) {
      const isSuggested = abhaAddressList.includes(selectedAbhaAddress);
      setIsManualAddress(!isSuggested);
      if (isSuggested) {
        setAddressAvailable(true);
        setAddressError("");
      } else {
        setAddressAvailable(null);
        setAddressError("");
      }
    }
  }, [selectedAbhaAddress, abhaAddressList]);

  // Email validation
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(value);
    setIsValidEmail(isValid);

    // Set error message
    if (value.length === 0) {
      setEmailError(""); // Don't show error if empty (optional field)
    } else if (!isValid) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const back = () => {
    if (showExistingAccountPopup) {
      // If existing account popup is shown, close it and go back to OTP screen
      setShowExistingAccountPopup(false);
      setExistingAccountData(null);
      setSelectedPhrAddress("");
      setExistingAccountPhrAddresses([]);
      setIsFromExistingAccountFlow(false);
      // Stay on OTP screen to allow user to try again or enter different details
      return;
    } else if (showAbhaAddressScreen) {
      // If on ABHA address screen, check if we came from existing account flow
      if (isFromExistingAccountFlow) {
        // Go back to existing account popup
        setShowAbhaAddressScreen(false);
        setShowExistingAccountPopup(true);
        setSelectedAbhaAddress("");
        setIsFromExistingAccountFlow(false);
      } else {
        // Go back to email screen (normal flow)
        setShowAbhaAddressScreen(false);
        setShowEmailScreen(true);
        setSelectedAbhaAddress("");
      }
    } else if (showEmailScreen) {
      // If on email screen, go back to mobile OTP screen
      setShowEmailScreen(false);
      setShowMobileOtpScreen(true);
    } else if (showMobileOtpScreen) {
      // If on mobile OTP screen, go back to Aadhar OTP screen
      setShowMobileOtpScreen(false);
      setShowOtpBox(true);
      setMobileOtpText("");
      setMobileOtpTimer(0);
      setMobileOtpResendCount(0);
    } else if (showOtpBox) {
      // If on OTP screen, go back to Aadhar entry
      setShowOtpBox(false);
      setOtpText("");
      setFormatedMobile("");
      setMobileNumber("");
      setCaptchaInput("");
      setResendCount(0);
      setCountdown(0);
      setCanResend(false);
      generateCaptcha();
    } else {
      // If on Aadhar entry screen, go back to home
      setAdharFormated("");
      setAdharno("");
      // setaccessToken("");
      setadharEncrpt("");
      setTxnId("");
      navigate("/abha-home");
    }
  };

  /**
   * Funtion used to be formate adhar number
   * @param {*} e
   */
  const adharNumberFormater = (e) => {
    const inputValue = e.target.value;

    if (showAadhar) {
      // When visible, extract numeric values directly
      const numericValue = inputValue.replace(/[^0-9]/g, "");
      const limitedValue = numericValue.slice(0, 12);
      setAdharno(limitedValue);
      const formattedValue = limitedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
      setAdharFormated(formattedValue);

      // Validate Aadhar
      if (limitedValue.length === 0) {
        setAadharError("Aadhaar number is required");
      } else if (limitedValue.length !== 12) {
        setAadharError("Aadhaar number must be 12 digits");
      } else {
        setAadharError("");
      }

      // Validate Aadhaar
      if (limitedValue.length === 0) {
        setAadharError("Aadhaar number is required");
      } else if (limitedValue.length < 12) {
        setAadharError("Aadhaar number must be 12 digits");
      } else {
        setAadharError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = adharFormated.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/[^0-9]/g, "").slice(-1);
        if (newDigit && adharno.length < 12) {
          const updatedValue = adharno + newDigit;
          setAdharno(updatedValue);
          const maskedValue = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          setAdharFormated(maskedValue);
        } else {
          // No new digit, just restore the mask
          const maskedValue = adharno
            .split("")
            .map(() => "*")
            .join("");
          setAdharFormated(maskedValue);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = adharno.slice(0, -1);
        setAdharno(updatedValue);
        const maskedValue = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        setAdharFormated(maskedValue);
      }

      // Validate Aadhaar for masked input
      const currentAadharLength =
        adharno.length + (newLength > currentLength ? 1 : -1);
      if (currentAadharLength === 0) {
        setAadharError("Aadhaar number is required");
      } else if (currentAadharLength !== 12) {
        setAadharError("Aadhaar number must be 12 digits");
      } else {
        setAadharError("");
      }
    }
  };
  /**
   * Function used to set otp text
   */
  const handleOtpChange = (e) => {
    const value = e.target.value;
    // Allow only digits and up to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setOtpText(value);
    }
  };
  /**
   * Function used to set mobile or formate in input box
   */
  const handleMobileInput = (e) => {
    const inputValue = e.target.value;

    if (showMobile) {
      // When visible, extract numeric values directly
      const numericValue = inputValue.replace(/[^0-9]/g, "");
      const limitedValue = numericValue.slice(0, 10);
      setMobileNumber(limitedValue);
      setFormatedMobile(limitedValue);

      // Validate mobile number
      if (limitedValue.length === 0) {
        setMobileError("Mobile number is required");
      } else if (limitedValue.length < 10) {
        setMobileError("Mobile number must be 10 digits");
      } else {
        setMobileError("");
      }
    } else {
      // When masked, compare lengths to determine if adding or removing
      const currentLength = formatedMobile.length;
      const newLength = inputValue.length;

      if (newLength > currentLength) {
        // User is adding a digit - extract the new digit
        const newDigit = inputValue.replace(/[^0-9]/g, "").slice(-1);
        if (newDigit && mobileNumber.length < 10) {
          const updatedValue = mobileNumber + newDigit;
          setMobileNumber(updatedValue);
          const maskedValue = updatedValue
            .split("")
            .map(() => "*")
            .join("");
          setFormatedMobile(maskedValue);
        } else {
          // No new digit, just restore the mask
          const maskedValue = mobileNumber
            .split("")
            .map(() => "*")
            .join("");
          setFormatedMobile(maskedValue);
        }
      } else if (newLength < currentLength) {
        // User is removing a digit (backspace)
        const updatedValue = mobileNumber.slice(0, -1);
        setMobileNumber(updatedValue);
        const maskedValue = updatedValue
          .split("")
          .map(() => "*")
          .join("");
        setFormatedMobile(maskedValue);
      }

      // Validate mobile number for masked input
      const currentMobileLength =
        mobileNumber.length + (newLength > currentLength ? 1 : -1);
      if (currentMobileLength === 0) {
        setMobileError("Mobile number is required");
      } else if (currentMobileLength < 10) {
        setMobileError("Mobile number must be 10 digits");
      } else {
        setMobileError("");
      }
    }
  };

  const toggleAadharVisibility = () => {
    setShowAadhar(!showAadhar);
    // Reformat the display
    if (!showAadhar && adharno) {
      // Switching to visible - show full number with spaces
      const formattedValue = adharno.replace(/(\d{4})(?=\d)/g, "$1 ");
      setAdharFormated(formattedValue);
    } else if (adharno) {
      // Switching to masked - show all asterisks
      const maskedValue = adharno
        .split("")
        .map(() => "*")
        .join("");
      setAdharFormated(maskedValue);
    }
  };

  const toggleMobileVisibility = () => {
    setShowMobile(!showMobile);
    // Reformat the display
    if (!showMobile && mobileNumber) {
      // Switching to visible - show full number
      setFormatedMobile(mobileNumber);
    } else if (mobileNumber) {
      // Switching to masked - show all asterisks
      const maskedValue = mobileNumber
        .split("")
        .map(() => "*")
        .join("");
      setFormatedMobile(maskedValue);
    }
  };

  /**
   * Funtion is used to be hadle all the process of the send otp, adhar encription and create token as well
   * @returns
   */
  const sendAdharOtp = async () => {
    // Validate all fields
    if (!adharno || adharno.length !== 12) {
      toast.error("Please enter a valid Aadhaar number (12 digits)");
      return;
    }
    if (!beneficiaryName || beneficiaryName.trim() === "") {
      toast.error("Please enter beneficiary name.");
      return;
    }
    if (!areAllConsentsChecked()) {
      toast.error("Please accept the required terms and conditions");
      return;
    }

    // Validate captcha with backend
    if (!captchaInput || captchaInput.trim() === "") {
      toast.error("Please enter the captcha.");
      return;
    }

    try {
      // Verify captcha with backend
      const captchaResponse = await axios.post(
        `${API_BASE_URL}/abha/captcha/validate`,
        {
          sessionId: captchaSessionId,
          captcha: captchaInput,
        },
      );

      if (!captchaResponse.data.success || !captchaResponse.data.valid) {
        toast.error("Invalid captcha. Please try again.");
        generateCaptcha(); // Regenerate captcha
        setCaptchaInput(""); // Clear input
        return;
      }
    } catch (error) {
      toast.error("Failed to validate captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    setIsPageLoading(true);
    const encryptedAdhar = await encryptString(adharno);
    if (!encryptedAdhar) {
      toast.error("Encryption failed. Please try again.");
    } else {
      try {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/enrollment/aadhar/send-otp`;
          const param = {
            loginId: encryptedAdhar,
          };
          // const accessToken = sessionResponse.accessToken;

          // setaccessToken(accessToken);
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: `${accessToken}`,
            },
          };

          const response = await axios.post(url, param, header);
          const dtResponse = response.data;

          if (dtResponse.success) {
            setTxnId(dtResponse.data.txnId);
            setShowOtpBox(true);
            setCountdown(60);
            setCanResend(false);
            toast.success(dtResponse?.data.message || "OTP sent successfully.");
            setIsPageLoading(false);
          } else {
            toast.error(
              dtResponse?.data.message ||
                "Failed to send OTP. Please try again.",
            );
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } catch (error) {
        setIsPageLoading(false);
        if (error.response) {
          // Backend returned an error response
          toast.error(
            error.response.data?.message ||
              "Server error occurred. Please try again later.",
          );
        } else if (error.request) {
          // Request made but no response received
          toast.error("No response from server. Please check your connection.");
        } else {
          // Something else happened
          toast.error("Something went wrong: " + error.message);
        }
      }
    }
  };

  const resendOtp = async () => {
    if (resendCount >= 3) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (!canResend) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    setIsPageLoading(true);
    const encryptedAdhar = await encryptString(adharno);
    if (!encryptedAdhar) {
      toast.error("Encryption failed. Please try again.");
      setIsPageLoading(false);
    } else {
      try {
        // const sessionResponse = await createSession();
        // if (sessionResponse?.accessToken) {
          const url = `${API_BASE_URL}/abha/enrollment/aadhar/send-otp`;
          const param = {
            loginId: encryptedAdhar,
          };
          // const newAccessToken = sessionResponse.accessToken;

          // setaccessToken(newAccessToken);
          const header = {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: `${newAccessToken}`,
            },
          };

          const response = await axios.post(url, param, header);
          const dtResponse = response.data;

          if (dtResponse.success) {
            setTxnId(dtResponse.data.txnId);
            setResendCount(resendCount + 1);
            setCountdown(60);
            setCanResend(false);
            toast.success(
              dtResponse?.data.message || "OTP resent successfully.",
            );
            setIsPageLoading(false);
          } else {
            toast.error(dtResponse?.data.message || "Failed to resend OTP.");
            setIsPageLoading(false);
          }
        // } else {
        //   toast.error("Session creation failed. Please try again.");
        //   setIsPageLoading(false);
        // }
      } catch (error) {
        setIsPageLoading(false);
        if (error.response) {
          toast.error(
            error.response.data?.message ||
              "Server error occurred. Please try again later.",
          );
        } else if (error.request) {
          toast.error("No response from server. Please check your connection.");
        } else {
          toast.error("Something went wrong: " + error.message);
        }
      }
    }
  };

  const verifyAdharOtp = async () => {
    try {
      if (!OtpText || OtpText.length !== 6) {
        toast.error("Please enter a valid 6-digit OTP.");
        return;
      }
      if (!mobileNumber || mobileNumber.length !== 10) {
        toast.error("Please enter a valid 10-digit mobile number");
        return;
      }

      setIsPageLoading(true);
      const encryptedOtp = await encryptString(OtpText);
      if (encryptedOtp) {
        const url = `${API_BASE_URL}/abha/enrollment/aadhar/verify-otp`;
        const param = {
          txnId: txnId,
          otpValue: encryptedOtp,
          mobile: mobileNumber,
        };
        const header = {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: `${accessToken}`,
          },
        };
        const response = await axios.post(url, param, header);
        const dtResponse = response.data;
        if (dtResponse.success) {
          // Check if account already exists
          if (dtResponse.data.message === "This account already exist") {
            // Store existing account data and show popup
            console.log("Existing account found:", dtResponse.data);
            const phrAddresses = dtResponse.data.ABHAProfile?.phrAddress || [];

            if (phrAddresses.length === 0) {
              // If no PHR addresses found, continue with new account creation
              toast.warning(
                "No existing PHR addresses found. Continuing with account creation...",
              );
              // localStorage.setItem("x_token", dtResponse.data.tokens.token);
              localStorage.setItem("loginMethod", "aadhar");
              localStorage.setItem(
                "abdmAccessToken",
                dtResponse.data.tokens.token,
              );
              setXToken(dtResponse.data.tokens.token);
              setTxnId(dtResponse.data.txnId);
              setIsPageLoading(false);
              setShowOtpBox(false);
              const aadharLinkedMobile0 = dtResponse.data.ABHAProfile?.mobile;
              if (aadharLinkedMobile0 && aadharLinkedMobile0 === mobileNumber) {
                setShowEmailScreen(true);
              } else {
                setShowMobileOtpScreen(true);
              }
              return;
            }

            setExistingAccountData(dtResponse.data);
            setExistingAccountPhrAddresses(phrAddresses);
            setSelectedPhrAddress(
              dtResponse.data.ABHAProfile.preferredAddress ||
                phrAddresses[0] ||
                "",
            );
            setIsPageLoading(false);
            const aadharLinkedMobileExisting =
              dtResponse.data.ABHAProfile?.mobile;
            if (
              aadharLinkedMobileExisting &&
              aadharLinkedMobileExisting === mobileNumber
            ) {
              setShowExistingAccountPopup(true);
            } else {
              // Different mobile - verify via OTP before showing popup
              // localStorage.setItem("x_token", dtResponse.data.tokens.token);
              setXToken(dtResponse.data.tokens.token);
              setTxnId(dtResponse.data.txnId);
              setShowOtpBox(false);
              setShowMobileOtpScreen(true);
            }
            return;
          }

          // New account - continue with flow
          // localStorage.setItem("x_token", dtResponse.data.tokens.token);
          localStorage.setItem("loginMethod", "aadhar");
          setXToken(dtResponse.data.tokens.token);
          setTxnId(dtResponse.data.txnId);
          setIsPageLoading(false);
          setShowOtpBox(false);
          // If entered mobile matches Aadhaar-linked mobile, skip mobile OTP
          const aadharLinkedMobile = dtResponse.data.ABHAProfile?.mobile;
          if (aadharLinkedMobile && aadharLinkedMobile === mobileNumber) {
            setShowEmailScreen(true);
          } else {
            setShowMobileOtpScreen(true);
          }
        } else {
          toast.error("Invalid Aadhaar OTP. Please try again.");
          setIsPageLoading(false);
        }
      } else {
        setIsPageLoading(false);
        toast.error("Encryption failed. Please try again.");
      }
    } catch (error) {
      setIsPageLoading(false);
      if (error.response) {
        // Backend returned an error response
        toast.error("Invalid Aadhaar OTP. Please try again.");
      } else if (error.request) {
        // Request made but no response received
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        toast.error("Something went wrong: " + error.message);
      }
    }
  };

  // Email verification
  const handleEmailVerification = async () => {
    try {
      setIsPageLoading(true);
      const encryptedEmail = await encryptString(email);
      if (encryptedEmail) {
        const response = await axios.post(
          `${API_BASE_URL}/abha/profile/email-verification-link`,
          { loginId: encryptedEmail },
          {
            headers: {
              "Content-Type": "application/json",
              // accesstoken: accessToken,
              // xtoken: xToken,
            },
          },
        );
        const dtResponse = response.data;
        if (dtResponse.success) {
          toast.success(
            dtResponse.message || "Email verification link sent successfully.",
          );
          // Continue to ABHA address selection
          handleSkipEmail();
        } else {
          toast.error(
            dtResponse.message || "Failed to send email verification link.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error("Failed to encrypt email.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Skip email verification
  const handleSkipEmail = async () => {
    try {
      setIsPageLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/abha/enrollment/abha-address-suggestions`,
        {
          headers: {
            // accesstoken: accessToken,
            "transaction-id": txnId,
          },
        },
      );
      const dtResponse = response.data;
      if (dtResponse.success) {
        setAbhaAddressList(dtResponse.data.abhaAddressList || []);
        setTxnId(dtResponse.data.txnId);
        setIsPageLoading(false);
        setShowEmailScreen(false);
        setShowAbhaAddressScreen(true);
      } else {
        toast.error(
          dtResponse.message || "Failed to fetch ABHA address suggestions.",
        );
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Send Mobile OTP
  const sendMobileOtp = async () => {
    try {
      setIsPageLoading(true);
      // const sessionResponse = await createSession();
      // if (!sessionResponse?.accessToken) {
      //   setIsPageLoading(false);
      //   toast.error("Failed to create session.");
      //   return;
      // }

      // Encrypt mobile number
      const encryptedMobile = await encryptString(mobileNumber);
      if (!encryptedMobile) {
        setIsPageLoading(false);
        toast.error("Failed to encrypt mobile number.");
        return;
      }

      const url = `${API_BASE_URL}/abha/update/mobile/send-otp`;
      const param = {
        loginId: encryptedMobile,
      };
      const header = {
        headers: {
          "Content-Type": "application/json",
          // xtoken: `${xToken}`,
          // accesstoken: `${sessionResponse.accessToken}`,
        },
      };

      const response = await axios.post(url, param, header);
      const dtResponse = response.data;

      if (dtResponse.success) {
        setMobileOtpTxnId(dtResponse.data.txnId);
        setMobileOtpTimer(60);
        setMobileOtpResendCount(0);
        setMobileOtpText("");
        toast.success(dtResponse.data.message || "OTP sent to mobile");
        setIsPageLoading(false);
      } else {
        toast.error(dtResponse?.message || "Failed to send OTP.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Resend Mobile OTP
  const resendMobileOtp = async () => {
    if (mobileOtpResendCount >= 2) {
      toast.error("Maximum resend attempts reached.");
      return;
    }
    if (mobileOtpTimer > 0) {
      toast.error("Please wait before resending OTP.");
      return;
    }

    try {
      const encryptedMobile = await encryptString(mobileNumber);
      setIsPageLoading(true);
      // const sessionResponse = await createSession();
      // if (!sessionResponse?.accessToken) {
      //   setIsPageLoading(false);
      //   toast.error("Failed to create session.");
      //   return;
      // }

      const url = `${API_BASE_URL}/abha/update/mobile/send-otp`;
      const param = {
        loginId: encryptedMobile,
      };
      const header = {
        headers: {
          "Content-Type": "application/json",
          // xtoken: `${xToken}`,
          // accesstoken: `${sessionResponse.accessToken}`,
        },
      };

      const response = await axios.post(url, param, header);
      const dtResponse = response.data;

      if (dtResponse.success) {
        setMobileOtpTxnId(dtResponse.data.txnId);
        setMobileOtpTimer(60);
        setMobileOtpResendCount(mobileOtpResendCount + 1);
        setMobileOtpText("");
        toast.success(dtResponse?.data?.message || "OTP resent successfully");
        setIsPageLoading(false);
      } else {
        toast.error(dtResponse?.message || "Failed to resend OTP.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Verify Mobile OTP
  const verifyMobileOtp = async () => {
    if (!mobileOtpText || mobileOtpText.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      setIsPageLoading(true);
      const encryptedOtp = await encryptString(mobileOtpText);
      if (!encryptedOtp) {
        setIsPageLoading(false);
        toast.error("Failed to encrypt OTP.");
        return;
      }

      // const sessionResponse = await createSession();
      // if (!sessionResponse?.accessToken) {
      //   setIsPageLoading(false);
      //   toast.error("Failed to create session.");
      //   return;
      // }

      const url = `${API_BASE_URL}/abha/update/mobile/verify-otp`;
      const param = {
        txnId: mobileOtpTxnId,
        otp: encryptedOtp,
      };
      const header = {
        headers: {
          "Content-Type": "application/json",
          // xtoken: `${xToken}`,
          // accesstoken: `${sessionResponse.accessToken}`,
        },
      };

      const response = await axios.post(url, param, header);
      const dtResponse = response.data;

      if (dtResponse.success) {
        if (
          dtResponse.data?.authResult &&
          dtResponse.data.authResult !== "success"
        ) {
          toast.error(
            dtResponse.data.message || "Invalid OTP. Please try again.",
          );
          setIsPageLoading(false);
          return;
        }
        toast.success(
          dtResponse.data.message || "Mobile OTP verified successfully",
        );
        setMobileOtpText("");
        setMobileOtpTimer(0);
        setShowMobileOtpScreen(false);
        if (existingAccountData) {
          setShowExistingAccountPopup(true);
        } else {
          setShowEmailScreen(true);
        }
        setIsPageLoading(false);
      } else {
        toast.error(
          dtResponse?.data?.message ||
            dtResponse?.message ||
            "Failed to verify OTP.",
        );
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Mobile OTP Timer Effect
  useEffect(() => {
    if (mobileOtpTimer > 0) {
      const timer = setTimeout(
        () => setMobileOtpTimer(mobileOtpTimer - 1),
        1000,
      );
      return () => clearTimeout(timer);
    }
  }, [mobileOtpTimer, showMobileOtpScreen]);

  // Send Mobile OTP when mobile OTP screen is shown
  useEffect(() => {
    if (showMobileOtpScreen && !mobileOtpTxnId) {
      sendMobileOtp();
    }
  }, [showMobileOtpScreen]);

  // Check ABHA address availability
  const checkAddressAvailability = async () => {
    if (!selectedAbhaAddress) {
      toast.error("Please enter an ABHA address.");
      return;
    }

    // Validate ABHA address format first
    const validation = validateAbhaAddress(selectedAbhaAddress);
    if (!validation.valid) {
      setAddressError(validation.error);
      return;
    }

    try {
      setIsCheckingAddress(true);
      setAddressError("");
      setAddressAvailable(null);

      // Add @sbx suffix to the address
      const addressWithSuffix = selectedAbhaAddress + "@sbx";

      const response = await axios.post(
        `${API_BASE_URL}/abha/profile/search`,
        {
          address: addressWithSuffix,
        },
        {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: accessToken,
          },
        },
      );

      const dtResponse = response.data;

      // If success is true, it means the address exists (already taken)
      if (dtResponse.success) {
        setAddressAvailable(false);
        setAddressError(
          "This ABHA address is already taken. Please try another one.",
        );
        toast.error("This ABHA address is already taken.");
      }
    } catch (error) {
      // Status 400 with "Invalid ABHA Address" or "User not found" means address is available
      if (
        error.response?.status === 400 ||
        (error.response?.data?.success === false &&
          (error.response?.data?.message === "User not found" ||
            error.response?.data?.message === "Failed to request login OTP" ||
            error.response?.data?.error?.[0]?.message ===
              "Invalid ABHA Address"))
      ) {
        setAddressAvailable(true);
        setAddressError("");
        toast.success("Great! This ABHA address is available.");
      } else {
        setAddressError("");
        toast.error(
          error.response?.data?.message ||
            "Failed to check address availability.",
        );
      }
    } finally {
      setIsCheckingAddress(false);
    }
  };

  // Create ABHA address
  const handleCreateAbhaAddress = async () => {
    if (!selectedAbhaAddress) {
      toast.error("Please select an ABHA address.");
      return;
    }
    try {
      setIsPageLoading(true);

      // Get xToken from state or localStorage as fallback
      // const currentXToken = xToken || localStorage.getItem("x_token");
      // if (!currentXToken) {
      //   toast.error(
      //     "Authentication token not found. Please try logging in again.",
      //   );
      //   setIsPageLoading(false);
      //   return;
      // }

      const response = await axios.post(
        `${API_BASE_URL}/abha/enrollment/create-abha-address`,
        {
          txnId: txnId,
          abhaAddress: selectedAbhaAddress,
        },
        {
          headers: {
            "Content-Type": "application/json",
            // accesstoken: accessToken,
          },
        },
      );
      const dtResponse = response.data;
      if (dtResponse.success) {
        // Fetch profile and redirect
        const abhaProfileData = await getAbhaProfile(
          // accessToken,
          null,
          null,
        );
        if (abhaProfileData?.success) {
          localStorage.setItem(
            "orignalBeneficiaryData",
            JSON.stringify(abhaProfileData?.data),
          );
          setIsPageLoading(false);
          toast.success("ABHA address created successfully!");
          navigate("/abha-Card");
        } else {
          toast.error(
            abhaProfileData?.message || "Failed to fetch ABHA profile data.",
          );
          setIsPageLoading(false);
        }
      } else {
        toast.error(dtResponse.message || "Failed to create ABHA address.");
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred. Please try again later.",
      );
    }
  };

  // Handle existing account login
  const handleExistingAccountLogin = async () => {
    if (!selectedPhrAddress) {
      toast.error("Please select a PHR address.");
      return;
    }

    try {
      setIsPageLoading(true);

      // If selected address is same as preferred address, redirect to /abha-card
      if (
        selectedPhrAddress === existingAccountData.ABHAProfile.preferredAddress
      ) {
        const abhaProfileData = await getAbhaProfile(
          // accessToken,
          null,
          existingAccountData.tokens.token,
        );
        if (abhaProfileData?.success) {
          localStorage.setItem(
            "orignalBeneficiaryData",
            JSON.stringify(abhaProfileData?.data),
          );
          localStorage.setItem("loginMethod", "aadhar");
          // localStorage.setItem("x_token", existingAccountData.tokens.token);
          localStorage.setItem(
            "abdmAccessToken",
            existingAccountData.tokens.token,
          );
          setIsPageLoading(false);
          setShowExistingAccountPopup(false);
          toast.success("Login successful!");
          navigate("/abha-Card");
          return;
        }
      } else {
        // Different address selected, redirect to ABHA address login with pre-filled address
        setIsPageLoading(false);
        setShowExistingAccountPopup(false);
        toast.info("Redirecting to ABHA address login...");
        navigate(
          `/login-ABHA?prefillAddress=${encodeURIComponent(selectedPhrAddress)}`,
        );
        return;
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error("Login failed. Please try again.");
    }
  };

  // Handle create new account
  const handleCreateNewAccount = async () => {
    if (!existingAccountData) {
      toast.error("Account data not found. Please try again.");
      return;
    }

    try {
      setIsPageLoading(true);

      // Store tokens first
      // localStorage.setItem("x_token", existingAccountData.tokens.token);
      localStorage.setItem("loginMethod", "aadhar");
      setXToken(existingAccountData.tokens.token);
      setTxnId(existingAccountData.txnId);
      // const sessionResponse = await createSession();
      // if (sessionResponse?.accessToken) {
      //   setaccessToken(sessionResponse.accessToken);
      // }

      // Fetch suggested addresses (same as handleSkipEmail logic)
      const response = await axios.get(
        `${API_BASE_URL}/abha/enrollment/abha-address-suggestions`,
        {
          headers: {
            // accesstoken: sessionResponse.accessToken,
            "transaction-id": existingAccountData.txnId,
          },
        },
      );

      const dtResponse = response.data;
      if (dtResponse.success) {
        setAbhaAddressList(dtResponse.data.abhaAddressList || []);
        setTxnId(dtResponse.data.txnId);

        // Close popup and show address selection screen with suggestions
        setShowExistingAccountPopup(false);
        setShowOtpBox(false);
        setShowMobileOtpScreen(false);
        setShowEmailScreen(false);
        setShowAbhaAddressScreen(true);
        setIsFromExistingAccountFlow(true); // Mark that we came from existing account flow
        setIsPageLoading(false);
        toast.info("Creating new PHR address with suggestions...");
      } else {
        toast.error(
          dtResponse.message || "Failed to fetch ABHA address suggestions.",
        );
        setIsPageLoading(false);
      }
    } catch (error) {
      setIsPageLoading(false);
      toast.error(
        error.response?.data?.message ||
          "Server error occurred while fetching suggestions.",
      );
    }
  };

  // Handle PHR address selection
  const handlePhrAddressSelect = (address) => {
    setSelectedPhrAddress(address);
  };

  return (
    <>
      <div className="mainFlow">
        <Navbar />
        <ToastContainer />
        {isPageLoading && <Loader />}

        {/* Existing Account Popup */}
        {showExistingAccountPopup && (
          <div
            className="modal fade show"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Account Already Exists</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowExistingAccountPopup(false);
                      setExistingAccountData(null);
                      setSelectedPhrAddress("");
                    }}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <strong>Welcome back!</strong> We found an existing ABHA
                    account linked to this Aadhar number.
                  </div>

                  <div className="mb-3">
                    <strong>Account Details:</strong>
                    <p className="mb-1">
                      Name: {existingAccountData?.ABHAProfile?.firstName}{" "}
                      {existingAccountData?.ABHAProfile?.middleName}{" "}
                      {existingAccountData?.ABHAProfile?.lastName}
                    </p>
                    <p className="mb-1">
                      ABHA Number:{" "}
                      {existingAccountData?.ABHAProfile?.ABHANumber}
                    </p>
                    <p className="mb-1">
                      Mobile: {existingAccountData?.ABHAProfile?.mobile}
                    </p>
                  </div>

                  <div className="mb-4">
                    <strong>Available PHR Addresses:</strong>
                    <div className="mt-2">
                      {existingAccountPhrAddresses.map((address, index) => (
                        <div key={index} className="form-check mb-2">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="phrAddress"
                            id={`phrAddress_${index}`}
                            value={address}
                            checked={selectedPhrAddress === address}
                            onChange={() => handlePhrAddressSelect(address)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`phrAddress_${index}`}
                          >
                            {address}
                            {address ===
                              existingAccountData?.ABHAProfile
                                ?.preferredAddress && (
                              <span className="badge bg-primary ms-2">
                                Preferred
                              </span>
                            )}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mb-3">
                    <p>
                      <strong>Choose an option:</strong>
                    </p>
                    <ul>
                      <li>
                        <strong>Login:</strong> Use selected PHR address to
                        access your existing account
                      </li>
                      <li>
                        <strong>Create New:</strong> Create a new PHR address
                        for this ABHA account
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={() => {
                      setShowExistingAccountPopup(false);
                      setExistingAccountData(null);
                      setSelectedPhrAddress("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-success me-2"
                    onClick={handleExistingAccountLogin}
                    disabled={!selectedPhrAddress}
                  >
                    Login with Selected Address
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleCreateNewAccount}
                  >
                    Create New PHR Address
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="container">
          <div className="pranHealtnMainUserFlow">
            <div className="abha-paranLogo">
              <img src={MixLogo} alt="Logo" />
            </div>
            <div className="userFlowAdharVer pre-create-ABHA">
              <div className="backArrow" onClick={back}>
                <i className="material-icons">keyboard_backspace</i>
              </div>

              {/* Mobile OTP Verification Screen */}
              {showMobileOtpScreen && (
                <>
                  <div className="flowTitle">
                    <h4>Mobile Verification</h4>
                  </div>
                  <div className="flow-feilds">
                    <div className="feilds">
                      <label>Mobile Number</label>
                      <input
                        type="text"
                        className="filds-form"
                        value={mobileNumber}
                        disabled
                        style={{ background: "#f5f5f5", cursor: "not-allowed" }}
                      />
                    </div>
                    <div className="feilds">
                      <label>
                        Confirm OTP <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Enter 6 digit OTP"
                        value={mobileOtpText}
                        autoComplete="off"
                        maxLength={6}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          setMobileOtpText(value);
                          if (value.length === 0) {
                            setMobileOtpError("OTP is required");
                          } else if (value.length < 6) {
                            setMobileOtpError("OTP must be 6 digits");
                          } else {
                            setMobileOtpError("");
                          }
                        }}
                      />
                      {mobileOtpError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {mobileOtpError}
                        </span>
                      )}
                      <span
                        className="notes text-end"
                        onClick={
                          mobileOtpTimer === 0 && mobileOtpResendCount < 2
                            ? resendMobileOtp
                            : null
                        }
                        style={{
                          pointerEvents:
                            mobileOtpTimer > 0 || mobileOtpResendCount >= 2
                              ? "none"
                              : "auto",
                          color:
                            mobileOtpTimer > 0 || mobileOtpResendCount >= 2
                              ? "#999"
                              : "#007bff",
                          cursor:
                            mobileOtpTimer > 0 || mobileOtpResendCount >= 2
                              ? "not-allowed"
                              : "pointer",
                          display: "block",
                          marginTop: "5px",
                        }}
                      >
                        {mobileOtpTimer > 0
                          ? `00:${mobileOtpTimer < 10 ? "0" + mobileOtpTimer : mobileOtpTimer} Resend OTP (${2 - mobileOtpResendCount} ${2 - mobileOtpResendCount === 1 ? "attempt" : "attempts"} left)`
                          : mobileOtpResendCount >= 2
                            ? "Maximum resend attempts reached"
                            : `Resend OTP (${2 - mobileOtpResendCount} ${2 - mobileOtpResendCount === 1 ? "attempt" : "attempts"} left)`}
                      </span>
                    </div>
                    <div className="feilds feildsBtn mt-5">
                      <button className="custBtn btnCancel" onClick={back}>
                        Back
                      </button>
                      <button
                        className={`custBtn ${mobileOtpText.length === 6 ? "btnSuccess" : "disabled"}`}
                        onClick={verifyMobileOtp}
                        disabled={mobileOtpText.length !== 6}
                      >
                        Verify <i className="material-icons">arrow_right_alt</i>
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* Email Verification Screen */}
              {showEmailScreen && (
                <>
                  <div className="flowTitle">
                    <h4>Communication Details</h4>
                  </div>
                  <div
                    style={{
                      backgroundColor: "#fff3cd",
                      padding: "15px",
                      borderRadius: "8px",
                      marginBottom: "20px",
                      border: "1px solid #ffeeba",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <i
                      className="material-icons"
                      style={{ color: "#856404", fontSize: "20px" }}
                    >
                      info
                    </i>
                    <span style={{ color: "#856404", fontSize: "14px" }}>
                      This Email address will be used for all communications
                      related to ABHA.
                    </span>
                  </div>
                  <div className="flow-feilds">
                    <div className="feilds">
                      <label>Enter email address</label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="email"
                          className="filds-form"
                          placeholder="Enter email address"
                          value={email}
                          onChange={handleEmailChange}
                          style={{
                            paddingRight: "40px",
                            paddingLeft: "12px",
                            width: "100%",
                            height: "45px",
                          }}
                          autoComplete="off"
                        />
                        {isValidEmail && (
                          <i
                            className="material-icons"
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#28a745",
                              fontSize: "20px",
                            }}
                          >
                            check_circle
                          </i>
                        )}
                      </div>
                      {emailError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {emailError}
                        </span>
                      )}
                    </div>
                    <div className="feilds feildsBtn mt-5">
                      <button
                        className="custBtn btnCancel"
                        onClick={handleSkipEmail}
                      >
                        Skip for now
                      </button>
                      <button
                        className={`custBtn ${isValidEmail ? "btnSuccess" : "disabled"}`}
                        onClick={handleEmailVerification}
                        disabled={!isValidEmail}
                        style={{
                          opacity: !isValidEmail ? 0.5 : 1,
                          cursor: !isValidEmail ? "not-allowed" : "pointer",
                        }}
                      >
                        Continue{" "}
                        <i className="material-icons">arrow_right_alt</i>
                      </button>
                    </div>
                  </div>
                </>
              )}

              {/* ABHA Address Selection Screen */}
              {showAbhaAddressScreen && (
                <>
                  <div className="flowTitle">
                    <h4>Create ABHA</h4>
                  </div>
                  <div className="flow-feilds">
                    <div className="feilds">
                      <label>
                        Enter ABHA address{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          className="filds-form"
                          placeholder="enter your desire abha address"
                          value={selectedAbhaAddress}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSelectedAbhaAddress(value);
                            // Validate on change if manual entry
                            if (isManualAddress && value) {
                              const validation = validateAbhaAddress(value);
                              setAddressError(validation.error);
                              // Reset availability status when user types
                              setAddressAvailable(null);
                            } else {
                              setAddressError("");
                            }
                          }}
                          style={{
                            paddingRight:
                              isManualAddress && selectedAbhaAddress
                                ? "150px"
                                : "80px",
                          }}
                        />
                        {/* Check Availability Button - only for manual input - inside input field */}
                        {isManualAddress && selectedAbhaAddress && (
                          <button
                            onClick={checkAddressAvailability}
                            disabled={isCheckingAddress || addressError}
                            style={{
                              position: "absolute",
                              right: "50px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              padding: "4px 10px",
                              backgroundColor: addressError
                                ? "#ccc"
                                : "#007bff",
                              color: "#fff",
                              border: "none",
                              borderRadius: "4px",
                              cursor:
                                isCheckingAddress || addressError
                                  ? "not-allowed"
                                  : "pointer",
                              fontSize: "11px",
                              fontWeight: "500",
                              opacity:
                                isCheckingAddress || addressError ? 0.6 : 1,
                              whiteSpace: "nowrap",
                            }}
                            title={addressError ? addressError : ""}
                          >
                            {isCheckingAddress ? "Checking..." : "Check"}
                          </button>
                        )}
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#666",
                            fontSize: "14px",
                          }}
                        >
                          @sbx
                        </span>
                      </div>
                      {addressError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {addressError}
                        </span>
                      )}
                      {addressAvailable === true && (
                        <span
                          style={{
                            color: "#28a745",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          ✓ ABHA address is available
                        </span>
                      )}
                      {addressAvailable === false && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          ABHA address is already taken
                        </span>
                      )}
                      {/* Success/Error Message */}
                      {addressAvailable === false && addressError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "14px",
                              verticalAlign: "middle",
                            }}
                          >
                            error
                          </i>{" "}
                          {addressError}
                        </span>
                      )}
                      {addressAvailable === true && isManualAddress && (
                        <span
                          style={{
                            color: "#28a745",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "14px",
                              verticalAlign: "middle",
                            }}
                          >
                            check_circle
                          </i>{" "}
                          This ABHA address is available!
                        </span>
                      )}

                      <div style={{ marginTop: "20px" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "10px",
                            fontWeight: "500",
                          }}
                        >
                          Suggestions
                        </label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                          }}
                        >
                          {abhaAddressList.map((address, index) => (
                            <button
                              key={index}
                              onClick={() => setSelectedAbhaAddress(address)}
                              style={{
                                padding: "8px 16px",
                                borderRadius: "20px",
                                border:
                                  selectedAbhaAddress === address
                                    ? "2px solid #007bff"
                                    : "1px solid #ddd",
                                backgroundColor:
                                  selectedAbhaAddress === address
                                    ? "#e7f3ff"
                                    : "#fff",
                                color:
                                  selectedAbhaAddress === address
                                    ? "#007bff"
                                    : "#333",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight:
                                  selectedAbhaAddress === address
                                    ? "600"
                                    : "400",
                                transition: "all 0.2s",
                              }}
                              onMouseOver={(e) => {
                                if (selectedAbhaAddress !== address) {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              }}
                              onMouseOut={(e) => {
                                if (selectedAbhaAddress !== address) {
                                  e.target.style.backgroundColor = "#fff";
                                }
                              }}
                            >
                              {address}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="feilds feildsBtn mt-5">
                      <button className="custBtn btnCancel" onClick={back}>
                        Back
                      </button>
                      <button
                        className={`custBtn ${selectedAbhaAddress && !addressError && (addressAvailable === true || !isManualAddress) ? "btnSuccess" : "disabled"}`}
                        onClick={handleCreateAbhaAddress}
                        disabled={
                          !selectedAbhaAddress ||
                          addressError ||
                          (isManualAddress && addressAvailable !== true)
                        }
                        style={{
                          opacity:
                            !selectedAbhaAddress ||
                            addressError ||
                            (isManualAddress && addressAvailable !== true)
                              ? 0.5
                              : 1,
                          cursor:
                            !selectedAbhaAddress ||
                            addressError ||
                            (isManualAddress && addressAvailable !== true)
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        Continue{" "}
                        <i className="material-icons">arrow_right_alt</i>
                      </button>
                    </div>
                  </div>
                </>
              )}

              {!showOtpBox &&
              !showEmailScreen &&
              !showAbhaAddressScreen &&
              !showMobileOtpScreen ? (
                <>
                  <div className="flowTitle">
                    <h4>Create ABHA via Aadhar</h4>
                    <p>OTP will be sent to the mobile number to the aadhar</p>
                  </div>
                  <div className="flow-feilds">
                    <div className="feilds">
                      <label>
                        Aadhar Number <span style={{ color: "red" }}>*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          ref={aadharInputRef}
                          type="text"
                          className="filds-form"
                          placeholder="Enter 12 digit Aadhar"
                          name="adharno"
                          value={adharFormated}
                          onChange={adharNumberFormater}
                          maxLength={showAadhar ? 14 : 12}
                          autoComplete="off"
                          style={{ paddingRight: "40px" }}
                        />
                        <i
                          className="material-icons"
                          onClick={toggleAadharVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        >
                          {showAadhar ? "visibility" : "visibility_off"}
                        </i>
                      </div>
                      {aadharError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {aadharError}
                        </span>
                      )}
                    </div>

                    <div className="feilds" style={{ marginTop: "15px" }}>
                      <div
                        style={{
                          backgroundColor: "#f5f5f5",
                          padding: "15px",
                          borderRadius: "8px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        {/* Name Input Fields */}
                        <div style={{ marginBottom: "15px" }}>
                          <div
                            className="feilds"
                            style={{ marginBottom: "15px" }}
                          >
                            <label
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                marginBottom: "5px",
                                display: "block",
                              }}
                            >
                              Beneficiary Name{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="text"
                              className="filds-form"
                              placeholder="Enter beneficiary name"
                              value={beneficiaryName}
                              onChange={(e) =>
                                setBeneficiaryName(e.target.value)
                              }
                              style={{
                                width: "100%",
                                fontSize: "13px",
                                padding: "8px",
                              }}
                            />
                          </div>
                        </div>

                        <AadharConsentSection
                          acceptAll={acceptAll}
                          handleAcceptAll={handleAcceptAll}
                          consent1={consent1}
                          setConsent1={setConsent1}
                          consent2={consent2}
                          setConsent2={setConsent2}
                          consent3={consent3}
                          setConsent3={setConsent3}
                          consent4={consent4}
                          setConsent4={setConsent4}
                          consent5={consent5}
                          setConsent5={setConsent5}
                          consent6={consent6}
                          setConsent6={setConsent6}
                          consent7={consent7}
                          setConsent7={setConsent7}
                          beneficiaryName={beneficiaryName}
                          setBeneficiaryName={setBeneficiaryName}
                          healthcareWorkerName={healthcareWorkerName}
                        />
                      </div>
                    </div>

                    <div className="feilds" style={{ marginTop: "15px" }}>
                      <label>
                        Captcha <span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f0f0f0",
                            padding: "5px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            flex: 1,
                            textAlign: "center",
                            userSelect: "none",
                            minHeight: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {captchaImage ? (
                            <img
                              src={captchaImage}
                              alt="Captcha"
                              style={{ maxWidth: "100%", height: "auto" }}
                            />
                          ) : (
                            <span style={{ color: "#999" }}>
                              Loading captcha...
                            </span>
                          )}
                        </div>
                        <i
                          className="material-icons"
                          onClick={generateCaptcha}
                          style={{ cursor: "pointer", fontSize: "24px" }}
                          title="Refresh Captcha"
                        >
                          refresh
                        </i>
                      </div>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Enter captcha text"
                        value={captchaInput}
                        onChange={(e) => {
                          setCaptchaInput(e.target.value);
                        }}
                        autoComplete="off"
                      />
                    </div>

                    <div className="feilds feildsBtn mt-5">
                      <button className="custBtn btnCancel" onClick={back}>
                        Back
                      </button>
                      <button
                        className="custBtn btnSuccess"
                        onClick={sendAdharOtp}
                        disabled={!adharno || adharno.length !== 12}
                        style={{
                          opacity: !adharno || adharno.length !== 12 ? 0.5 : 1,
                          cursor:
                            !adharno || adharno.length !== 12
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        Continue{" "}
                        <i className="material-icons">arrow_right_alt</i>
                      </button>
                    </div>
                  </div>
                </>
              ) : null}

              {showOtpBox && (
                <>
                  <div className="flowTitle">
                    <h4>Create ABHA via Aadhar</h4>
                  </div>
                  <div className="flow-feilds">
                    <div className="feilds">
                      <label>Aadhar Number</label>
                      <input
                        type="text"
                        className="filds-form"
                        value={"**** **** " + adharno.slice(-4)}
                        disabled
                        style={{
                          backgroundColor: "#f5f5f5",
                          cursor: "not-allowed",
                        }}
                      />
                    </div>

                    <div className="feilds" style={{ marginTop: "15px" }}>
                      <label>Confirm OTP</label>
                      <input
                        type="text"
                        className="filds-form"
                        placeholder="Enter OTP"
                        maxLength={6}
                        value={OtpText}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          handleOtpChange({ target: { value } });
                          if (value.length === 0) {
                            setOtpError("OTP is required");
                          } else if (value.length < 6) {
                            setOtpError("OTP must be 6 digits");
                          } else {
                            setOtpError("");
                          }
                        }}
                      />
                      {otpError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {otpError}
                        </span>
                      )}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "8px",
                          fontSize: "13px",
                        }}
                      >
                        {countdown > 0 ? (
                          <span style={{ color: "#666" }}>
                            {`00:${countdown < 10 ? "0" + countdown : countdown} Resend OTP (${3 - resendCount} ${3 - resendCount === 1 ? "attempt" : "attempts"} left)`}
                          </span>
                        ) : resendCount < 3 && canResend ? (
                          <button
                            onClick={resendOtp}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#007bff",
                              cursor: "pointer",
                              textDecoration: "underline",
                              padding: 0,
                            }}
                          >
                            Resend OTP ({3 - resendCount}{" "}
                            {3 - resendCount === 1 ? "attempt" : "attempts"}{" "}
                            left)
                          </button>
                        ) : resendCount >= 3 ? (
                          <span style={{ color: "#dc3545" }}>
                            Max attempts reached
                          </span>
                        ) : null}
                      </div>
                    </div>

                    <div className="feilds" style={{ marginTop: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          marginBottom: "8px",
                        }}
                      >
                        <label style={{ margin: 0 }}>
                          Communication Mobile number{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <i
                            className="material-icons"
                            onMouseEnter={() => setShowMobileTooltip(true)}
                            onMouseLeave={() => setShowMobileTooltip(false)}
                            style={{
                              fontSize: "16px",
                              color: "#ff9800",
                              cursor: "help",
                            }}
                          >
                            info
                          </i>
                          {showMobileTooltip && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "100%",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "#fff3cd",
                                color: "#856404",
                                padding: "10px",
                                borderRadius: "4px",
                                fontSize: "12px",
                                width: "250px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                zIndex: 1000,
                                marginBottom: "5px",
                                border: "1px solid #ffeeba",
                              }}
                            >
                              It is preferable to use your Aadhaar-linked mobile
                              number. If you choose to use a different mobile
                              number, it will need to be validated again and
                              will be used for all communication related to
                              ABHA.
                            </div>
                          )}
                        </div>
                      </div>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="text"
                          className="filds-form"
                          placeholder="Enter 10 digit Mobile Number"
                          value={formatedMobile}
                          onChange={handleMobileInput}
                          autoComplete="off"
                          style={{ paddingRight: "40px", width: "100%" }}
                        />
                        <i
                          className="material-icons"
                          onClick={toggleMobileVisibility}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        >
                          {showMobile ? "visibility" : "visibility_off"}
                        </i>
                      </div>
                      {mobileError && (
                        <span
                          style={{
                            color: "#dc3545",
                            fontSize: "12px",
                            marginTop: "5px",
                            display: "block",
                          }}
                        >
                          {mobileError}
                        </span>
                      )}
                    </div>

                    <div className="feilds feildsBtn mt-5">
                      <button className="custBtn btnCancel" onClick={back}>
                        Back
                      </button>
                      <button
                        className="custBtn btnSuccess"
                        onClick={verifyAdharOtp}
                        disabled={
                          !OtpText ||
                          OtpText.length !== 6 ||
                          !mobileNumber ||
                          mobileNumber.length !== 10
                        }
                        style={{
                          opacity:
                            !OtpText ||
                            OtpText.length !== 6 ||
                            !mobileNumber ||
                            mobileNumber.length !== 10
                              ? 0.5
                              : 1,
                          cursor:
                            !OtpText ||
                            OtpText.length !== 6 ||
                            !mobileNumber ||
                            mobileNumber.length !== 10
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        Verify <i className="material-icons">arrow_right_alt</i>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AadharVerificationPage;
